import { Button, Table, Input, Row, Col, Modal, Radio, message, Typography, Select, Card, Tag, Space} from "antd";
import { useEffect, useRef, useState, } from "react";
import Highlighter from 'react-highlight-words';
import api from "../../API";
import * as XLSX from 'xlsx';
import { DownloadOutlined, SearchOutlined, SyncOutlined } from "@ant-design/icons";

function ZNSTemplate() {
    const user = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = useState({table: false, btn: false, exp: false, index: 0});
    const [dataSource, setDataSource] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [options, setOptions] = useState(null);
    const [selectedOAIndex, setselectedOAIndex] = useState(null);
    const originalZnsTemplate = useRef([]);
    const originalOAAccounts = useRef([]);
  
    const getStatusTagColor = (status) => {
        switch (status) {
          case 'PENDING_REVIEW':
            return 'processing';
          case 'DISABLE':
            return 'default';
          case 'ENABLE':
            return 'success';
          case 'REJECT':
            return 'error';
          default:
            return 'default';
        }
    };
    
    const getQualityTagColor = (quality) => {
    switch (quality) {
        case 'HIGH':
        return 'green';
        case 'MEDIUM':
        return 'gold';
        case 'LOW':
        return 'orange';
        case 'UNDEFINED':
        return 'default';
        default:
        return 'default';
    }
    };

    const columns = [
      {
        title: "Name",
        dataIndex: "templateName",
        width: 250,
        render: (text, record) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "Template ID",
        dataIndex: "templateId",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "OA Account",
        dataIndex: "accountName",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (status) => {
          const color = getStatusTagColor(status);
          const label = status?.toUpperCase();
    
          if (!searchText) {
            return <Tag color={color}>{label}</Tag>;
          }
    
          return (
            <Tag color={color}>
              <Highlighter
                highlightStyle={{
                  backgroundColor: '#ffc069',
                  padding: 0,
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={label}
              />
            </Tag>
          );
        },
      },
      {
        title: "Template Quality",
        dataIndex: "templateQuality",
        render: (quality) => {
          const color = getQualityTagColor(quality);
          const label = quality?.toUpperCase();
    
          if (!searchText) {
            return <Tag color={color}>{label}</Tag>;
          }
    
          return (
            <Tag color={color}>
              <Highlighter
                highlightStyle={{
                  backgroundColor: '#ffc069',
                  padding: 0,
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={label}
              />
            </Tag>
          );
        },
      },
      {
        title: 'Action',
        key: 'action',
        width: 100,
        align: 'center',
        render: (_, record) => (
          <Button 
            type="primary" 
            loading={loading.exp && loading.index === record?.key}
            icon={<DownloadOutlined />}
            onClick={() => handleExportAsXlsx(record?.templateId, record?.OAId, record?.key)}>
          </Button>),
      }
    ];
  
    useEffect(() => {
      setLoading({...loading, table: true});
      Promise.all([
        api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id","accountName" , "OAId"]),
        api.list_all_znstemplates(user?.userId)])
      .then(([oaacounts, znstemplates]) => {
        originalZnsTemplate.current = znstemplates.length? znstemplates.map(znstemplate => ({
          key: znstemplate.id,
          OAId: znstemplate.OAId,
          templateName: znstemplate.templateName,
          templateId: znstemplate.templateId,
          templateQuality: znstemplate.templateQuality,
          status: znstemplate.status,
          accountName: oaacounts.find(oaacount => oaacount.OAId === znstemplate.OAId)?.accountName,
        })) : [];
        originalOAAccounts.current = oaacounts;
        setOptions(oaacounts.map((oaacount, i) => ({
          value: i,
          label: oaacount.accountName
        })))
        setDataSource(originalZnsTemplate.current); 
      })
      .catch(err => message.error(err.message))
      setLoading({...loading, table: false});
    }, []);

    function handleselectedOAIndex(OAIndex) {
      let newZnsTemplates = originalZnsTemplate.current;
      if(OAIndex || OAIndex === 0) newZnsTemplates = newZnsTemplates.filter(value => value.OAId === originalOAAccounts.current[OAIndex].OAId);
      if(searchText) newZnsTemplates = newZnsTemplates.filter((o) => Object.keys(o).slice(2).some((k) => o[k] && String(o[k])
        .toLowerCase()
        .includes(searchText.toLowerCase())));
      setLoading(true);
      setselectedOAIndex(OAIndex);
      setDataSource(newZnsTemplates);
      setLoading(false);
    }
  
    function handleSearchInfo(e) {
      let newZnsTemplates = originalZnsTemplate.current;
      if(selectedOAIndex || selectedOAIndex === 0) newZnsTemplates = newZnsTemplates.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
      if(e.target.value) newZnsTemplates = newZnsTemplates.filter((o) => Object.keys(o).slice(3).some((k) => o[k] && String(o[k])
        .toLowerCase()
        .includes(e.target.value.toLowerCase())));
      setLoading(true);
      setSearchText(e.target.value);
      setDataSource(newZnsTemplates);
      setLoading(false);
    }
  
    async function handleUpdateZnsTemplates() {
      setLoading({...loading, btn: true});
      try {
        const res = await api.list_all_znstemplates_on_zalo(user?.userId, user?.parentId, originalOAAccounts.current[selectedOAIndex]?.OAId);
        if(res) {
          const resZnsTemplates = await api.list_all_znstemplates(user?.userId);
          let newZnsTemplates = resZnsTemplates.map(znstemplate => {
            const oaacountObj = originalOAAccounts.current.find(oaacount => oaacount.OAId === znstemplate.OAId);
            return{
                key: znstemplate.id,
                OAId: znstemplate.OAId,
                templateName: znstemplate.templateName,
                templateId: znstemplate.templateId,
                templateQuality: znstemplate.templateQuality,
                status: znstemplate.status,
                accountName: oaacountObj?.accountName
          }})
            originalZnsTemplate.current = newZnsTemplates.concat();
            if(selectedOAIndex  || selectedOAIndex === 0) newZnsTemplates = newZnsTemplates.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
            setDataSource(newZnsTemplates);
        } else {
          message.error();
        }
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading({...loading, btn: false});
      }
    }
  
    async function handleExportAsXlsx(templateId, OAId, key) {
      try {
        setLoading({ ...loading, exp: true, index: key });
    
        const tblNames = await api.list_znstemplate_detail_on_zalo(
          user?.parentId ? user.parentId : user.userId,
          OAId,
          templateId
        );
    
        tblNames?.unshift('delivery_phone'); 
        const data = [tblNames];
    
        const worksheet = XLSX.utils.aoa_to_sheet(data); // aoa = array of array
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'ZNS Template');
    
        XLSX.writeFile(workbook, 'zns-template.xlsx');
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading({ ...loading, exp: false });
      }
    }
    
  
    return (
      <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
          <Typography.Title level={5} style={{margin: 0}}>Zns Templates</Typography.Title>
        }
        loading={loading.table}
        extra={<Button type="primary" style={{padding:15}} loading={loading.btn} onClick={handleUpdateZnsTemplates} icon={<SyncOutlined />}>Update ZNS</Button>}
      >
        <Row gutter={[16,16]}  align="middle">
          <Col sm={24} xs={24} md={12}>
            <Select 
              style={{width:'100%'}}
              placeholder="Select OA Id"
              popupMatchSelectWidth={false}
              value={selectedOAIndex}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={handleselectedOAIndex}
              options={options}
            />
          </Col>
          <Col sm={24} xs={24} md={12}>
            <Input 
                placeholder="Input search text"
                allowClear
                onChange={handleSearchInfo}
                suffix={<SearchOutlined />}/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table  
              bordered
              scroll={{x: 1100}}
              columns= {columns} 
              style={{marginTop: 16, width: '100%'}} 
              dataSource={dataSource}
              loading={loading.table}
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: false, 
                pageSize: 10, 
                showTotal: () => `Total: ${dataSource.length} items`
              }}
              />
          </Col>
        </Row>
      </Card>
    )
}

export default ZNSTemplate
